/* assets/upgrade-newsletter-popup.js -- the newsletter pop-up's behaviour (snippets/upgrade-newsletter-popup.liquid).
   V1.23 PATCH, 13 Oct 2026; FIX ROUND 1 same day, FIX ROUND 2 on 14 Oct (2026-10-13_v1.23-newsletter-popup/build/CHANGES.md,
   build/FIX-ROUND-1.md, build/FIX-ROUND-2.md). Deferred, ASCII only, no library.

   WHEN IT OPENS (owner's decisions, 13 Oct 2026)
     - once per visitor: after the delay (data-delay on the root, from the theme setting; 15 s by default), counted
       from the start of the page and never sooner than 3 s after this file runs (a page slow to arrive is seen first),
       or when a desktop mouse leaves the window at the top, whichever comes first. A tab switch does not start it
       early: coming back to a tab asks again only once the delay has passed;
     - not again for 30 days after it is closed (or shown and left); never again after a sign-up. The memory is read
       again each time it is about to open, so a close or a sign-up in ANOTHER tab silences this tab as well;
     - never over another overlay (the shop filter sheet says aria-modal while it is open; the phone menu, the photo
       viewer, any open dialog), never over the trade-in tool or a product page's buy box while the visitor is using
       it (the phone's sticky Add to cart bar, [data-ug-pdp-sticky], counts as the buy box: a tap, a click or the focus
       in it holds the pop-up back for 8 s, so it cannot open over an add to cart in flight or its error message), never
       while the visitor is typing in a field. It then asks again every 1.5 s, for 2 minutes at most;
     - never in a tab nobody is looking at (it waits for the tab to come back), never in the theme editor.
     The pages it never appears on (trade-in, sell, cart, account, search) do not get this file at all.

   THE STYLESHEET is not in the page's HTML (see "the stylesheet" below): the snippet gives the root its address in data-css and this
   file makes the <link> itself, after the page has loaded, in idle time, so nothing waits for it while the page is being built.

   MEMORY. One key, "ug_nlp", in localStorage: "s" = subscribed; "c<ms>" = shown or closed at that time. Every storage
   call is in try/catch. With no usable storage it falls back to sessionStorage, then to a token in window.name, so it
   shows at most once per session (per tab). A 'storage' event closes a dialog left open when another tab subscribes.

   THE FORM posts natively (Shopify's {% form 'customer' %}); nothing is fetched or sent from here. The page comes back
   with ?customer_posted=true (the success text is shown, the visitor is remembered as subscribed) or with form.errors
   (the error is shown and the field gets focus). Both returns drop the #fragment first: left in the URL, the
   browser's own jump to the form takes the focus off the field a few ms after it is given.

   ACCESSIBILITY. role=dialog, aria-modal and aria-labelledby are in the markup. On open, focus moves into the dialog
   and Tab / Shift+Tab stay in it; Escape, the backdrop and the close button close it, and focus goes back to
   where it was. */
(function () {
  'use strict';
  if (window.__ugNlp) return;
  window.__ugNlp = true;

  var root = document.querySelector('[data-ug-nlp]');
  if (!root) return;
  /* The theme editor (Customize) shows the page with html.shopify-design-mode (set in the head by layout/theme.liquid). A pop-up that opened
     there would cover the page the content team is editing, every time it reloads, so it does not run there; the preview link shows it. */
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  var panel = root.querySelector('[data-ug-nlp-panel]');
  var fields = root.querySelector('[data-ug-nlp-fields]');
  var okEl = root.querySelector('[data-ug-nlp-ok]');
  var errEl = root.querySelector('[data-ug-nlp-err]');
  var emailEl = root.querySelector('input[type="email"]');
  var form = root.querySelector('form');
  var cssHref = root.getAttribute('data-css');
  var css = null;          // the stylesheet's <link>: made by loadCss(), it is not in the page's HTML
  if (!panel || !fields || !okEl || !cssHref) return;

  var KEY = 'ug_nlp';
  var QUIET_MS = 30 * 24 * 60 * 60 * 1000;
  var TOKEN = 'ug_nlp_seen';
  var delay = Math.max(5, Math.min(120, parseInt(root.getAttribute('data-delay'), 10) || 15)) * 1000;
  var BUSY = '[data-ug-pdp-buybox],[data-ug-pdp-sticky],[data-ug-pdp-trade],.ug-pdp__tradein,.ug-engine';
  var OVERLAY = 'html.ug-gal-open,html.ug-lock,body.overflow-hidden,dialog[open],.ug-header__mobile-nav.is-open,cart-drawer.active';
  var FOCUSABLE = 'a[href],button,input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  var shown = false;       // the dialog is open
  var done = false;        // it has been opened once on this page, or the visitor is quiet (the timers stop)
  var due = false;         // the delay timer has run: a tab coming back may ask now (never before)
  var prev = null;         // what had focus before it opened
  var touched = 0;         // when the visitor last used the buy box or the trade-in tool
  var tries = 0;
  var retry = null;
  var waiting = false;     // waiting for the stylesheet
  var GRACE = 2500;        // 2.0 (L-10): ms to stay away after a watched overlay closes (closing puts focus back; the pop-up must not take it)
  var closedAt = 0;        // when the last watched overlay went away
  var seenOverlay = false;

  /* ---- memory ---- */
  function pick() {
    var names = ['localStorage', 'sessionStorage'];
    for (var i = 0; i < names.length; i++) {
      try {
        var s = window[names[i]];
        s.setItem('__ug_nlp_t', '1');
        s.removeItem('__ug_nlp_t');
        return s;
      } catch (e) { /* blocked or full: try the next */ }
    }
    return null;
  }
  var store = pick();
  function read() { try { return store ? store.getItem(KEY) : null; } catch (e) { return null; } }
  function write(v) { try { if (store) store.setItem(KEY, v); } catch (e) { /* ignore */ } }
  function sessionSeen() { try { return String(window.name || '').indexOf(TOKEN) !== -1; } catch (e) { return false; } }
  function markSession() { try { if (!sessionSeen()) window.name = (window.name ? window.name + ' ' : '') + TOKEN; } catch (e) { /* ignore */ } }
  function quiet() {
    var v = read();
    if (v === 's') return true;
    if (v && v.charAt(0) === 'c') {
      var age = Date.now() - (parseInt(v.slice(1), 10) || 0);
      if (age >= 0 && age < QUIET_MS) return true;
    }
    return !store && sessionSeen();
  }
  function remember() {
    if (read() === 's') return;
    if (store) write('c' + Date.now()); else markSession();
  }

  /* ---- is it a bad moment? ---- */
  function inside(el, sel) { return !!(el && el.closest && el.closest(sel)); }
  function visible(el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); }
  function mark(e) { if (inside(e.target, BUSY)) touched = Date.now(); }
  ['pointerdown', 'touchstart', 'click', 'keydown', 'focusin', 'input', 'change'].forEach(function (n) {
    document.addEventListener(n, mark, { capture: true, passive: true });
  });
  /* an element that says aria-modal counts only while it is drawn: some stay in the page, hidden, all the time */
  function overlayOpen() {
    if (document.querySelector(OVERLAY)) return true;
    var m = document.querySelectorAll('[aria-modal="true"]');
    for (var i = 0; i < m.length; i++) {
      if (m[i] !== panel && visible(m[i]) && window.getComputedStyle(m[i]).visibility !== 'hidden') return true;
    }
    return false;
  }
  /* 2.0 (L-10): note the moment a watched overlay goes away. A narrow observer (class / open / aria-modal / hidden
     changes, answered with one querySelector and no layout read). Started with the timer, so a visitor who will
     never see the pop-up pays nothing; it stops once the pop-up has been shown. */
  function watchOverlays() {
    if (!window.MutationObserver) return;
    seenOverlay = !!document.querySelector(OVERLAY);
    var mo = new MutationObserver(function () {
      if (done) { mo.disconnect(); return; }
      var now = !!document.querySelector(OVERLAY);
      if (seenOverlay && !now) closedAt = Date.now();
      seenOverlay = now;
    });
    mo.observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['class', 'open', 'hidden', 'aria-modal'] });
  }
  function busy() {
    var a = document.activeElement;
    if (overlayOpen()) return true;
    if (document.documentElement.classList.contains('ug-has-deal')) return true;
    if (inside(a, BUSY) || Date.now() - touched < 8000) return true;
    if (a && !root.contains(a) && /^(input|textarea|select)$/i.test(a.tagName || '')) return true;
    return !!(a && a.isContentEditable);
  }

  /* ---- the stylesheet ----
     Not in the page's HTML: a <link rel="stylesheet"> in the body holds back the end of parsing (domInteractive, every deferred script)
     until the file has arrived, and nothing needs it for ~15 s (build/FIX-ROUND-2.md). Its address is the root's data-css. warm() asks for
     it once the page has loaded, in idle time; open() asks too (late load event, return from a sign-up, exit intent). A quiet visitor
     never reaches start(), so never asks at all.
     WHERE it goes matters: the theme's own sheets (upgrade-core.css, upgrade-material.css, the section sheets) are links in the BODY (the
     header group renders upgrade-head), and of two rules of the same specificity the later sheet wins. In <head> this sheet came before all
     of them and lost every tie (the close button's focus ring took the sheet's top corners). The end of <body> is where it stood in round 1. */
  function loadCss() {
    if (css) return;
    css = document.createElement('link');
    css.rel = 'stylesheet';
    css.id = 'ug-nlp-css';
    css.href = cssHref;
    (document.body || document.documentElement).appendChild(css);
  }
  function warm() {
    var ask = function () { if (window.requestIdleCallback) window.requestIdleCallback(loadCss, { timeout: 4000 }); else setTimeout(loadCss, 1000); };
    if (document.readyState === 'complete') ask(); else window.addEventListener('load', ask);
  }

  /* ---- open and close ---- */
  function fit() {
    var vv = window.visualViewport;
    if (!vv) return;
    root.style.setProperty('--ug-nlp-top', vv.offsetTop + 'px');
    root.style.setProperty('--ug-nlp-h', vv.height + 'px');
  }
  function view(v) {
    fields.hidden = v === 'ok';
    okEl.hidden = v !== 'ok';
  }
  function open(v) {
    if (shown) return;
    loadCss();
    if (!css.sheet) {                                              // the stylesheet has not arrived: open the moment it has
      if (!waiting) { waiting = true; css.addEventListener('load', function () { open(v); }); }
      return;
    }
    shown = true;
    done = true;
    prev = document.activeElement;
    view(v === 'ok' ? 'ok' : 'form');
    if (v !== 'err' && errEl) errEl.hidden = true;
    fit();
    root.hidden = false;
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('focusin', onFocus, true);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', fit);
      window.visualViewport.addEventListener('scroll', fit);
    }
    var to = v === 'ok' ? okEl : (v === 'err' && emailEl ? emailEl : panel);
    try { to.focus({ preventScroll: true }); } catch (e) { to.focus(); }
    if (v !== 'ok') remember();
  }
  function close() {
    if (!shown) return;
    shown = false;
    root.hidden = true;
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('focusin', onFocus, true);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', fit);
      window.visualViewport.removeEventListener('scroll', fit);
    }
    if (okEl.hidden) remember();
    if (prev && prev !== document.body && document.contains(prev) && prev.focus) {
      try { prev.focus({ preventScroll: true }); } catch (e) { prev.focus(); }
    }
    prev = null;
  }
  function onKey(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var all = panel.querySelectorAll(FOCUSABLE), list = [], a = document.activeElement, i;
    for (i = 0; i < all.length; i++) if (!all[i].disabled && visible(all[i])) list.push(all[i]);
    if (!list.length) { e.preventDefault(); panel.focus(); return; }
    /* "out" is anywhere that is not one of the stops: outside the dialog, the dialog itself, or something inside it that is not in the list. The success
       text is the last kind (tabindex="-1", given focus by open('ok') so that it is read out): with the first two as the only tests, one Tab from it ran the
       browser's default, which left the page (the address bar), because nothing focusable follows it. Now Tab goes to the first stop and Shift+Tab to the last
       (both are Close in the success state). Release fix round 2, 15 Oct 2026. */
    var first = list[0], last = list[list.length - 1], out = !panel.contains(a) || a === panel || list.indexOf(a) === -1;
    if (e.shiftKey && (a === first || out)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || out)) { e.preventDefault(); first.focus(); }
  }
  /* Focus that leaves the dialog is brought back, except into an iframe: Shopify puts its own spam-protection check (a captcha) on the
     form, and if that ever shows a challenge, the challenge is an iframe and must be able to take focus. */
  function onFocus(e) { var t = e.target; if (shown && !panel.contains(t) && !(t && t.tagName === 'IFRAME')) panel.focus(); }

  root.addEventListener('click', function (e) {
    if (e.target === root || inside(e.target, '[data-ug-nlp-backdrop]') || inside(e.target, '[data-ug-nlp-close]')) close();
  });

  /* ---- when ---- */
  function attempt() {
    if (done || shown) return;
    if (quiet()) { done = true; clearTimeout(retry); return; }    // closed or subscribed in another tab since this page loaded
    if (document.visibilityState === 'hidden') return;            // asked again when the tab comes back
    var cool = GRACE - (Date.now() - closedAt);
    if (cool > 0) { clearTimeout(retry); retry = setTimeout(attempt, cool + 50); return; }   // an overlay has just closed: ask again when the grace is over (deferred, not dropped)
    if (busy()) {
      if (++tries < 80) { clearTimeout(retry); retry = setTimeout(attempt, 1500); }
      return;
    }
    open('form');
  }
  function start() {
    watchOverlays();
    warm();
    var wait = delay - (window.performance && performance.now ? performance.now() : 0);
    setTimeout(function () { due = true; attempt(); }, Math.max(3000, wait));   // never sooner than 3 s after the script runs, on a page that was slow to arrive
    document.addEventListener('visibilitychange', function () {
      if (due && document.visibilityState === 'visible') setTimeout(attempt, 1000);   // only once the delay has passed, not on every tab switch
    });
    window.addEventListener('storage', function (e) {             // another tab subscribed: an open dialog here is stale
      if (e.key === KEY && e.newValue === 's' && shown && okEl.hidden) close();
    });
    if (window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var leave = function (e) { if (e.relatedTarget == null && e.clientY <= 5) attempt(); };
      document.addEventListener('mouseout', leave);
      document.addEventListener('mouseleave', leave, true);
    }
  }

  /* ---- coming back from a sign-up ---- */
  function tidy(search) { try { history.replaceState(history.state, '', location.pathname + search); } catch (e) { /* ignore */ } }
  var returned = /[?&]customer_posted=true(?:&|#|$)/.test(location.search);
  var ownError = !!errEl && (location.hash === '#' + (form && form.id) || /^(?:\/[a-z]{2}(?:-[a-z]{2,4})?)?\/contact\/?$/i.test(location.pathname));
  if (returned && !okEl.hidden) {
    write('s');
    tidy(location.search.replace(/([?&])customer_posted=true&?/, '$1').replace(/[?&]$/, ''));
    open('ok');
  } else if (ownError) {
    tidy(location.search);                                        // no #fragment: the browser would jump to the form and take the focus off the field
    open('err');
  } else {
    view('form');
    if (errEl) errEl.hidden = true;
    if (!quiet()) start();
  }
})();
